export function Loader() {
  return (
    <div className="loading">
      Loading...
    </div>
  );
}